
import { withRouter } from 'react-router';
import { compose, lifecycle, renderComponent, withState, branch } from 'recompose';
import config from '../../../config';
import Loader from '../../components/Loader';
import { checkStatus } from '../../utils/helpers';

const LOADING_STATE = -1;

const withBrandContextProvider = compose(
  withRouter,
  withState('brand', 'setBrand', {}),

  lifecycle({
    componentDidMount() {
      if (this.props.brand === LOADING_STATE) {
        return;
      }

      this.props.setBrand(LOADING_STATE);

      fetch(`${config.url}/brand/${this.props.params.brandId}`).then(
        async (res) => {
          const brand = await checkStatus(res);
          this.props.setBrand(brand);
        }
      );
    },
  }), branch(
    props => props.brand === LOADING_STATE,
    renderComponent(Loader),
  ),
);

export default withBrandContextProvider;



// WEBPACK FOOTER //
// ./src/app/notifications/hoc/withBrandContextProvider.js